import { Text } from '@/theme/index';
import { DateUtil } from '@/utils/index';

export interface DatesSeenProps {
  datesLabel: string;
  firstDateSeen: string;
  lastDateSeen: string;
}

export function DateRange({
  datesLabel,
  firstDateSeen,
  lastDateSeen,
}: DatesSeenProps) {
  const dateUtil = new DateUtil();
  const showDates = firstDateSeen || lastDateSeen;
  const dateText = [
    dateUtil.parseDateFromString(firstDateSeen, 'MMM yyyy'),
    dateUtil.parseDateFromString(lastDateSeen, 'MMM yyyy'),
  ]
    .filter((date) => Boolean(date))
    .join(' - ');

  return (
    <>
      {showDates ? (
        <Text mb="5" color="secondary.contrastText" variant="caption">
          {datesLabel} {dateText}
        </Text>
      ) : null}
    </>
  );
}
